import React, { FC, HTMLAttributes } from 'react'
import cx from 'classnames'
import { Icon } from 'components/Icon'
import styles from './Spinner.module.scss'

type SpinnerProps = HTMLAttributes<HTMLSpanElement> & {
  label?: string
}

export const Spinner: FC<SpinnerProps> = ({ label = 'Loading', className, ...rest }) => {
  return (
    <Icon
      name="loader-4-line"
      className={cx(styles.spinner, className)}
      draggable="false"
      role="progressbar"
      aria-valuetext={label}
      data-testid="spinner"
      {...rest}
    />
  )
}

Spinner.displayName = 'Spinner'
